module.exports = __webpack_public_path__ + "static/img/MHB.5962a92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MHB.png
// module id = SuGD
// module chunks = 34